import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import React,{ PropsWithChildren } from "react";
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "../Header";
import "./index.scss";
export interface LayoutProps extends ComponentBase.Component {
  scrollable?: boolean;
  backgroundImage?: boolean;
  header?: React.ReactNode;
}
export const LayoutDom = ({
  className,
  children,
  scrollable = false,
  backgroundImage = true,
  header,
}: LayoutProps,ref:any) => {
  const b = createBEM("i-layout");
  return (
    <div className={cn(b({ bg: backgroundImage }), className)}>
      {header}
      <div ref={ref} className={b("main", { scrollable })}>{children}</div>
    </div>
  );
};

export const Layout = React.forwardRef(LayoutDom);

export const LayoutWithHeader = ({
  title,
  bg,
  back = true,
  customer,
  children,
}: PropsWithChildren<{
  title: string;
  bg?: boolean;
  back?: boolean;
  customer?: boolean;
}>) => {
  return (
    <Layout
      scrollable
      backgroundImage={!!bg}
      header={
        <Header
          title={title}
          leftActions={back ? <HeaderActionBack /> : undefined}
          rightActions={customer ? <HeaderActionCustomerService /> : undefined}
        />
      }
    >
      {children}
    </Layout>
  );
};
